import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
// import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import IntagramIcon from '@mui/icons-material/Instagram';
import YoutubeIcon from '@mui/icons-material/YouTube';

import logoLight from '../assets/images/static/logo-light.png';
import logoDark from '../assets/images/static/logo-dark.png';

const scrollToSection = (sectionId) => {
  const sectionElement = document.getElementById(sectionId);
  const offset = 128;
  if (sectionElement) {
    const targetScroll = sectionElement.offsetTop - offset;
    sectionElement.scrollIntoView({ behavior: 'smooth' });
    window.scrollTo({
      top: targetScroll,
      behavior: 'smooth'
    });
  }
};

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" mt={1}>
      {'Copyright © '}
        Phorm &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

Footer.propTypes = {
  mode: PropTypes.oneOf(['dark', 'light']).isRequired
};

export default function Footer(props) {

  const logoStyle = {
    width: props.mode === 'light' ? '150px' : '90px',
    height: 'auto'
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 2, sm: 4 },
        py: { xs: 2, sm: 2 },
        textAlign: { sm: 'center', md: 'left' }
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          width: '100%',
          justifyContent: 'space-between'
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            minWidth: { xs: '100%', sm: '60%' }
          }}>
          <Box sx={{ width: { xs: '100%', sm: '60%' } }}>
            <Box sx={{mb: 1.5, textAlign: { xs: 'center', md: 'left' } }}>
              <img
                src={props.mode === 'light' ? logoDark : logoLight}
                style={logoStyle}
                alt="Grupo Phorm"
              />
            </Box>
            <Typography variant="body2" fontWeight={600} gutterBottom>
              Nossos objetivos
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={2}>
            Ser a plataforma líder de acesso a academias, serviços e comércio fitness no Brasil, reconhecida pela sua conveniência, segurança e qualidade.
            </Typography>
          </Box>

          <Box sx={{ width: { xs: '100%', sm: '60%' } }}>
            <Typography variant="body2" fontWeight={600} gutterBottom>
              E-mail: contato@phorm.com.br
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: { xs: 'none', sm: 'flex' },
            flexDirection: 'column',
            gap: 1
          }}>
          <Typography variant="body2" fontWeight={600}>
            Mapa do site
          </Typography>
          <Link
            color="text.secondary"
            onClick={() => scrollToSection('AboutPlatform')}
            sx={{ cursor: 'pointer' }}>
            Conheça a phorm
          </Link>
          <Link
            color="text.secondary"
            onClick={() => scrollToSection('AboutUS')}
            sx={{ cursor: 'pointer' }}>
            Conheça a nossa história
          </Link>
          <Link
            color="text.secondary"
            onClick={() => scrollToSection('CompanyContact')}
            sx={{ cursor: 'pointer' }}>
            Empresas
          </Link>
          <Link
            color="text.secondary"
            onClick={() => scrollToSection('PartnersContact')}
            sx={{ cursor: 'pointer' }}>
            Torne-se um parceiro
          </Link>
          {/* <Link
            color="text.secondary"
            onClick={() => scrollToSection('features')}
            sx={{ cursor: 'pointer' }}>
            Rede Parceira
          </Link> */}
          <Link
            color="text.secondary"
            onClick={() => scrollToSection('faq')}
            sx={{ cursor: 'pointer' }}>
            FAQ
          </Link>
          {/* <Link
            color="text.secondary"
            onClick={() => scrollToSection('hero')}
            sx={{ cursor: 'pointer' }}>
            Entre em contato
          </Link> */}
          <Link
            color="text.secondary"
            href="https://app.phorm.com.br/"
            target="_blank">
            Acesse a plataforma
          </Link>
        </Box>
      </Box>
      {/*  */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          pt: { xs: 2, sm: 8 },
          width: '100%',
          borderTop: '1px solid',
          borderColor: 'divider'
        }}>
        <Copyright />
        <Stack
          direction="row"
          justifyContent="left"
          spacing={1}
          useFlexGap
          sx={{
            color: 'text.secondary'
          }}>
          <IconButton
            color="inherit"
            href="https://www.instagram.com/phorm.oficial/"
            target="_blank"
            aria-label="LinkedIn"
            sx={{ alignSelf: 'center' }}>
            <IntagramIcon />
          </IconButton>

          <IconButton
            color="inherit"
            href="https://www.youtube.com/@PHORMTV"
            target="_blank"
            aria-label="LinkedIn"
            sx={{ alignSelf: 'center' }}>
            <YoutubeIcon />
          </IconButton>
        </Stack>
      </Box>
    </Container>
  );
}
